import styled from '@emotion/styled';

export const AccordionWrapper = styled.div`
    &:nth-of-type(1) {
        border-top: none;
        padding: 0;
        margin: 0 0 0.75rem 0;

        & .a-accordion__headline {
                padding: 0;
                margin: 0;
        }
        
        & .a-accordion__headline__localized {
                padding: 0;
                margin-top: 0.5rem;
                margin-bottom: 0.5rem;
        }
    }
`;

export const AccordionHeadline = styled.div`
    display: inline-grid;
    grid-template-columns: max-content 1fr 15fr;
    column-gap: 0.3rem;

    & .sub-headline {
        font-size: xx-small;
    }
`;

export const AccordionContent = styled.div`
    padding: 0;
    margin: 0 0 0.75rem 0;
`;

export const AccordionLocalizedHeadline = styled.div`
    display: inline-grid;
    grid-template-columns: max-content 1fr 15fr;
    column-gap: 0.3rem;
    font-size: 1rem;
    font-weight: bold;
`;
